import { ManualCodeEntry } from '@/components/manual-code-entry/component';
import { Scanner } from '@/components/scanner';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Button, Flex } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useBaleProcessedContext } from '../hook';

export const BaleProcessedScanPage = () => {
	const { handleScan, showManualCodeEntry, setShowManualCodeEntry } = useBaleProcessedContext();
	const [code, setCode] = useState('');
	const navigate = useNavigate();

	return (
		<MobileContainer
			header={
				<MobileHeader
					title="Processed Bale Scan"
					onClose={() => navigate({ to: '/facility/home' })}
				/>
			}
		>
			<Scanner onScan={handleScan} />
			<ManualCodeEntry
				value={code}
				setValue={setCode}
				open={showManualCodeEntry}
				instructions="Please enter either the docket ID or a code from any of the bales."
				onClose={() => setShowManualCodeEntry(false)}
				actions={({ onClose }) => {
					return (
						<Flex>
							<Button variant="filled" bg="grey" c="white" fullWidth onClick={onClose}>
								Cancel
							</Button>
							<Button
								disabled={!code}
								variant="filled"
								fullWidth
								onClick={() => {
									handleScan(code);
								}}
							>
								Submit
							</Button>
						</Flex>
					);
				}}
			/>
		</MobileContainer>
	);
};
